"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagSource = void 0;
exports.instanceOfFeatureFlagSource = instanceOfFeatureFlagSource;
exports.FeatureFlagSourceFromJSON = FeatureFlagSourceFromJSON;
exports.FeatureFlagSourceFromJSONTyped = FeatureFlagSourceFromJSONTyped;
exports.FeatureFlagSourceToJSON = FeatureFlagSourceToJSON;
exports.FeatureFlagSourceToJSONTyped = FeatureFlagSourceToJSONTyped;
/**
 * Where the flag is set. CONFIG flags come from the app/api/public/feature_flags SSM parameter and cannot be edited or deleted through the API.
 * @export
 */
exports.FeatureFlagSource = {
    Database: 'DATABASE',
    Config: 'CONFIG'
};
function instanceOfFeatureFlagSource(value) {
    for (const key in exports.FeatureFlagSource) {
        if (Object.prototype.hasOwnProperty.call(exports.FeatureFlagSource, key)) {
            if (exports.FeatureFlagSource[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function FeatureFlagSourceFromJSON(json) {
    return FeatureFlagSourceFromJSONTyped(json, false);
}
function FeatureFlagSourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function FeatureFlagSourceToJSON(value) {
    return value;
}
function FeatureFlagSourceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FeatureFlagSource.js.map